import React from "react";
import { FaAngleRight } from "react-icons/fa";

import { ITableActiveFilter, ITableFilter } from "./Interfaces";
import { ZeosFilterButton } from "./ZeosFilterButton";

interface IProps {
  data: any[];
  filters: ITableFilter[] | undefined;
  activeFilters: ITableActiveFilter[];
}

export const ZeosFilterGroup = (props: IProps) => {
  return (
    <div className="flex items-end justify-between h-full p-4 bg-white shadow-sm border border-gray-200 mb-2">
      <div>
        <h2 className="text-lg font-semibold">Categories</h2>
        {props.filters
          ?.slice()
          .sort((a, b) => {
            if (a.value === "Unknown") return 1;
            if (b.value === "Unknown") return -1;
            if (a.value === "Other") return 1;
            if (b.value === "Other") return -1;
            return a.value.localeCompare(b.value);
          })
          .map((item) => {
            const hasMatch = props.data.some(
              (row) => row[item.columnIndex] === item.value
            );
            return (
              <ZeosFilterButton
                key={item.value + item.columnIndex}
                filterKey={item.value + item.columnIndex}
                label={item.value}
                columnIndex={item.columnIndex}
                active={
                  props.activeFilters.filter(
                    (filter) =>
                      filter.filterKey === item.value + item.columnIndex
                  ).length > 0
                }
                setActive={item.setActive}
                disabled={!hasMatch}
              />
            );
          })}
      </div>
      {/* Ask the Incentive Agent — hidden until functionality is ready
      <div>
        <h2 className="text-lg font-semibold">Ask the Incentive Agent</h2>
        <div className="h-[35px] text-md flex items-center bg-white text-gray-500 border-[1px] border-zeos-grey-md rounded-[4px] px-2">
          <input
            className="border-none outline-none"
            type="text"
            placeholder=""
          />
          <div className="h-3/4 w-[.75px] bg-zeos-grey-md"></div>
          <div className="h-full flex justify-center items-center px-2 text-zeos-orange-dk">
            <FaAngleRight />
          </div>
        </div>
      </div>
      */}
    </div>
  );
};
